import { Step } from './step-engine-constants';

export const viewsMapping = new Map([
  [Step.JOURNEY_HOME_PAGE, 'claim-steps/journey-home-page'],
  [Step.DAMAGED_GOOD_FAMILY, 'claim-steps/damaged-good-family'],
  [Step.DAMAGED_GOOD_SELECTION, 'claim-steps/damaged-good-selection'],
  [Step.CUSTOMER_INFORMATION, 'claim-steps/customer-information'],
  [Step.COVER_SELECTION, 'claim-steps/cover-selection'],
  [Step.CLAIM_TRIGGER_NATURE, 'claim-steps/claim-trigger-nature'],
  [Step.DAMAGED_GOOD_IMEI_VALIDATION, 'claim-steps/damaged-good-imei-validation'],
  [Step.DAMAGED_GOOD_SERIAL_NUMBER_VALIDATION, 'claim-steps/damaged-good-serial-number-validation'],
  [Step.DAMAGED_GOOD_CREATION, 'claim-steps/damaged-good-creation'],
  [Step.DAMAGED_GOOD_USER_CONFIRMATION, 'claim-steps/damaged-good-user-confirmation'],
  [Step.DAMAGED_GOOD_USER_CREATION, 'claim-steps/damaged-good-user-creation'],
  [Step.DAMAGED_GOOD_DATE, 'claim-steps/damaged-good-date'],
  [Step.EXTERNAL_DAMAGE_CONFIRMATION, 'claim-steps/external-damage-confirmation'],
  [Step.CLAIM_RESULT_SELECTION, 'claim-steps/claim-result-selection'],
  [Step.CHOOSE_DAMAGED_GOODS, 'claim-steps/choose-damaged-goods'],
  [Step.CLAIM_LOCATION, 'claim-steps/claim-location'],
  [Step.UPLOAD_DECLARATION, 'claim-steps/upload-declaration'],
  [Step.DAMAGED_GOOD_DYSFUNCTION_SELECTION, 'claim-steps/damaged-good-dysfunction-selection'],
  [Step.CLAIM_RESULT_FREE_ENTRY, 'claim-steps/claim-result-free-entry'],
  [Step.DAMAGED_GOOD_DYSFUNCTION_FREE_ENTRY, 'claim-steps/damaged-good-dysfunction-free-entry'],
  [Step.DAMAGED_GOOD_CIRCONSTANCES, 'claim-steps/damaged-good-circonstances'],
  [Step.DAMAGED_GOOD_ACCESSORIES_VALIDATION, 'claim-steps/damaged-good-accessories-validation'],
  [Step.CLIENT_DETAILS_CONFIRMATION, 'claim-steps/client-details-confirmation'],
  [Step.UPDATE_CLIENT_DETAILS, 'claim-steps/update-client-details'],
  [Step.DECLARATION_SUMMARY, 'claim-steps/declaration-summary'],
  [Step.IMPROVEMENT_QUALITY, 'claim-steps/improvement-quality'],
  [Step.DECLARATION_CONFIRMATION, 'claim-steps/declaration-confirmation'],
  [Step.TRAVEL_ASSISTANCE, 'claim-steps/information-page-reminder'],
  [Step.CONTACT_MODE, 'contact-steps/contact-mode'],
  [Step.CONTACT_FORM, 'contact-steps/contact-form'],
  [Step.CLAIM_DECLARE_CONTACT_FORM, 'contact-steps/contact-form'],
  [Step.CONFIRM_EMAIL, 'contact-steps/confirm-email'],
  [Step.NEED_HELP, 'need-help/need-help'],
  [Step.DAMAGED_GOOD_PROPER_USE_CONFIRMATION, 'claim-steps/damaged-good-proper-use-confirmation'],
  [Step.OTHER_CLAIM_TRIGGER_NATURE, 'claim-steps/other-claim-trigger-nature'],
  [Step.DAMAGED_GOOD_PROPER_FUNCTIONING_CONFIRMATION, 'claim-steps/damaged-good-proper-functioning-confirmation'],
  [Step.DEVICE_DOES_NOT_TURN_ON_CONFIRMATION, 'claim-steps/device-does-not-turn-on-confirmation'],
  [Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION, 'claim-steps/damaged-good-reparation-period-confirmation'],
  [Step.DAMAGED_GOOD_REPARATION_PERIOD_CONFIRMATION_APPLE, 'claim-steps/damaged-good-reparation-period-confirmation'],
  [Step.DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION, 'claim-steps/damaged-good-replaced-period-confirmation'],
  [Step.DAMAGED_GOOD_REPLACED_PERIOD_CONFIRMATION_APPLE, 'claim-steps/damaged-good-replaced-period-confirmation'],
  [Step.DAMAGE_OBSERVED_FREE_ENTRY, 'claim-steps/damage-observed-free-entry'],
  [Step.STOLEN_TYPE_SELECTION, 'claim-steps/stolen-type-selection'],
  [Step.PHYSICAL_VIOLENCE_CONFORMATION, 'claim-steps/physical-violence-confirmation'],
  [Step.THEFT_INSURED_PERSON_ELIGIBILITY, 'claim-steps/theft-insured-person-eligibility'],
  [Step.THEFT_PLACE_SELECTION, 'claim-steps/theft-place-selection'],
  [Step.THEFT_ADDRESS_VALIDATION, 'claim-steps/theft-address-validation'],
  [Step.THEFT_ACCESSORIES_VALIDATION, 'claim-steps/theft-accessories-validation'],
  [Step.THEFT_POLICE_REPORT_CONFIRMATION, 'claim-steps/theft-report-police-confirmation'],
  [Step.DEVICE_SIM_CARD_IN_OPPOSITION_CONFIRMATION, 'claim-steps/device-sim-card-in-opposition-confirmation'],
  [Step.REMPLACEMENT_DEVICE_NEW_SIM_REQUEST, 'claim-steps/remplacement-device-new-sim-request'],
  [Step.BURGLARY_DEVICE_SELECTION, 'claim-steps/burglary-device-selection'],
  [Step.BURGLARY_LOCATION_ACTIVE_CONFIRMATION, 'claim-steps/burglary-location-active-confirmation'],
  [Step.EXTERNAL_PRODUCT_VISIBLE_CONFIRMATION, 'claim-steps/external-product-visible-confirmation'],
  [Step.CLANDESTINE_INTRODUCTION_PLACE_SELECTION, 'claim-steps/clandestine-introduction-place-selection'],
  [Step.INTRODUCTION_CLANDESTINE_PLACE_OCCUPIED_CONFIRMATION, 'claim-steps/introduction-clandestine-place-occupied-confirmation'],
  [Step.PRODUCT_IN_HAND_CONFIRMATION, 'claim-steps/product-in-hand-confirmation'],
  [Step.PRODUCT_IN_BAG_CONFIRMATION, 'claim-steps/product-in-bag-confirmation'],
  [Step.PRODUCT_IN_POCKET_CONFIRMATION, 'claim-steps/product-in-pocket-confirmation'],
  [Step.REFERENTIAL_ITEMS, 'claim-steps/referential-items'],
  [Step.SUPPORTING_DOCUMENTS, 'claim-steps/supporting-documents'],
  [Step.CONTACT_MANAGEMENT_SERVICE, 'claim-steps/contact-management-service'],
  [Step.DEADLINE_REMINDER_CONFIRMATION, 'claim-steps/information-page-reminder'],
  [Step.COMPLAINED_TO_MERCHANT_CONFIRMATION, 'claim-steps/complained-to-merchant-confirmation'],
  [Step.CAPITAL_SHIPPING_ADDRESS_CONFIRMATION, 'claim-steps/capital-shipping-address-confirmation'],
  [Step.BENEFIT_TYPE_SELECTION, 'benefit-steps/benefit-type-selection'],
  [Step.BENEFIT_TYPE_SELECTION_APPLE, 'benefit-steps/benefit-type-selection'],
  [Step.BENEFIT_DEPOSIT_METHOD, 'benefit-steps/benefit-deposit-method'],
  [Step.DEVICE_PATTERN_LOCK, 'benefit-steps/device-pattern-lock'],
  [Step.REGISTERED_STATEMENT, 'benefit-steps/registered-statement'],
  [Step.TRANSPORT_VOUCHER_GENERATION_VALIDATION, 'benefit-steps/transport-voucher-generation-validation'],
  [Step.TRANSPORT_VOUCHER_GENERATION_INFORMATION, 'benefit-steps/transport-voucher-generation-information'],
  [Step.UPDATE_BENEFIT_ADDRESS_DETAILS, 'benefit-steps/update-benefit-address-details'],
  [Step.INSTRUCTIONS_FOR_PACKING, 'benefit-steps/instructions-for-packing'],
  [Step.TRANSPORT_VOUCHER_GENERATION, 'benefit-steps/transport-voucher-generation'],
  [Step.BENEFIT_INFORMATIVE_MESSAGE_DATA_SECURITY, 'benefit-steps/benefit-informative-message-data-security'],
  [Step.REGISTERED_STATEMENT_WITH_ANNOUNCEMENT, 'benefit-steps/registered-statement-with-announcement'],
  [Step.BENEFIT_POINT_SELECTION, 'benefit-steps/benefit-point-selection'],
  [Step.BENEFIT_CHOSEN_RELAY_POINT_VALIDATION, 'benefit-steps/benefit-chosen-point-validation'],
  [Step.BENEFIT_CHOSEN_PROXIMITY_POINT_VALIDATION, 'benefit-steps/benefit-chosen-point-validation'],
  [Step.INSTRUCTIONS_FOR_DEACTIVATING_FIND_MY_IPHONE, 'benefit-steps/instructions-for-deactivating-find-my-iphone'],
  [Step.DEACTIVATE_DEVICE_GEOLOCATION_CONFIRMATION, 'benefit-steps/deactivate-device-geolocation-confirmation'],
  [Step.CLAIM_DECLARATION_DATE, 'claim-steps/claim-declaration-date'],
  [Step.CONCERNED_ELEMENT_SELECTION, 'claim-steps/concerned-element-selection'],
  [Step.COMPLAINED_TO_POLICE_REMINDER, 'claim-steps/information-page-reminder'],
  [Step.EXTERNAL_REFERENCE, 'claim-steps/external-reference'],
  [Step.RELATIONSHIP_TO_THE_VICTIM, 'claim-steps/relationship-to-the-victim'],
  [Step.DAMAGED_GOOD_ACCESSORIES_SELECTION, 'claim-steps/damaged-good-accessories-selection'],
  [Step.RECOVERY_METHOD, 'claim-steps/recovery-method'],
  [Step.UPDATE_RECOVERY_ADDRESS, 'claim-steps/update-recovery-address'],
  [Step.COMPLAINED_TO_POLICE_CONFIRMATION, 'claim-steps/complained-to-police-confirmation'],
  [Step.OVERSEAS_DEPARTMENTS_AND_TERRITORIES_REMINDER, 'claim-steps/information-page-reminder'],
]);
